import React from "react";
import "./EmptyState.css";

/* ============================================================================
   EmptyState — nothing to show, said properly.

   All three detail sheets used to render a bare unstyled <p> ("Not Any Courier
   In This Policy"). Empty is a normal outcome here — most policies never have
   a claim — so it should read as information, not as a failure.
   ============================================================================ */

const EmptyState = ({ icon = "fa-inbox", title, text, meta }) => (
  <div className="empty">
    <span className="empty__icon">
      <i className={`fa ${icon}`} aria-hidden="true"></i>
    </span>
    <h2 className="empty__title">{title}</h2>
    {text && <p className="empty__text">{text}</p>}
    {/* Which policy this is about. On an empty sheet the rows are gone, and
        they were the only thing carrying the policy number — so without this
        the customer is looking at an unlabelled screen. */}
    {meta && <p className="empty__meta">{meta}</p>}
  </div>
);

export default EmptyState;
